export enum SCHEDULE_STATUS {
  DONE = '10',
  CANCELED = '15',
  MISSED = '20',
  AWAITING_APPROVAL = '25',
  NOT_APPROVED = '30',
  CONFIRMED = '35',
  APPROVED = '40'
}

export enum SCHEDULE_OTHER_STATUS {
  REQUESTED = 'R',
  EXECUTION = 'P',
  CANCELED = 'X',
}

export enum WaitingListStatus {
  WAITING = 'A',
  ATTENDED = 'E',
  CANCELLED = 'C'
}